import React, { useEffect, useState, Fragment } from "react";
import moment from "moment";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import DayPicker, { DateUtils } from 'react-day-picker';
import Spinner from "../common/spinner";
import useWindowWidth from '../common/hooks/useWindowWidth';

const dateToday = moment();
const dateYesterday = moment().add(-1, "days");
const dateTodayDropDownItem = dateToday.format("ddd, MMM D");
const dateTodaySelected = dateToday.format("MMMM DD, YYYY");
const dateYesterdayDropDownItem = dateYesterday.format("ddd, MMM D");
const dateYesterdaySelected = dateYesterday.format("MMMM DD, YYYY");
const lastMonthDropDownItem = moment().add(-1, "months").format("ddd, MMM D") + "-" + dateToday.format("ddd, MMM D");

const VisitHistory = ({ visits, getAppointmentHistory, isWaiting,  employeeRole, providerid, departmentid }) => {
    const windowWidth = useWindowWidth();
    const [visitData, setVisits] = useState();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedOption, setOption] = useState({ date: "Last 30 Days", option: 0, actualDate: '30 Days' });

    const serverData = window.serverData && window.serverData.data ? window.serverData.data : {};
    const { onTheFlyDepartmentId = null, onTheFlyVisitTypeId = null } = serverData;

    const toggle = () => {
        if (event && event.target && event.target.classList && event.target.classList.contains("custom")) {
            return;
        }
        setDropdownOpen(prevState => !prevState);
    }

    const { option, date } = selectedOption;
    const [range, setRange] = useState({ from: undefined, to: undefined });

    useEffect(() => {
        if (!(providerid || departmentid)) return;
        const { actualDate, option } = selectedOption;       
        let startDate = "", endDate = "";
        if (!actualDate) return;
        if (actualDate === "30 Days" && option!== 3) {
            startDate = moment().add(-1, "months").format("MM/DD/YYYY");
            endDate = dateToday.format("MM/DD/YYYY");
        }
        else if (actualDate.indexOf(',') > -1) {
            const [s = "", t = ""] = actualDate.split(",");
            if (!s || !t) return;
            startDate = s;
            endDate = t;
        }
        else {
            if (actualDate === "TODAY" && option !== 3) {
                const dateString = dateToday.format("MM/DD/YYYY");
                startDate = dateString;
                endDate = dateString;
            }
            else if (actualDate === "YESTERDAY" && option !== 3) {
                const dateString = dateYesterday.format("MM/DD/YYYY");
                startDate = dateString;
                endDate = dateString;
            }
        }
         if (startDate && endDate)
                getAppointmentHistory(startDate, endDate, providerid, departmentid);
    }, [selectedOption, providerid, departmentid]);
   
    const handleDayClick = (day, modifiers = {}) => {
        if (modifiers.disabled) {
            return;
        }      
        setRange(day && range.from && range.to ? {from: day, to: undefined} : DateUtils.addDayToRange(day, range));       
    }

    useEffect(() => {
        const { from, to } = range || {};
        let rangeText = "";
        if (from)
            rangeText = `${moment(from).format("MMMM DD, YYYY")}`;
        if (to)
            rangeText = rangeText + ` - ${moment(to).format("MMMM DD, YYYY")}`;
        if (!(from || to))
            rangeText = "Select custom range";
       
        if (from && to) {                  
            setOption(prevState => {
                return {
                    ...prevState,
                    date: rangeText,
                    actualDate: `${moment(from).format("MM/DD/YYYY")},${moment(to).format("MM/DD/YYYY")}`
                };
            });
            toggle();
        }
    }, [range]);

    useEffect(() => {
        if (!visits ) return;
        const visitsSorted = visits
            .slice()
            .sort((a, b) => new Date(b.startDateTime) - new Date(a.startDateTime));
        const visitsFiltered = visitsSorted.reduce((acc, visit) => {
            let { dateOfAppt, ...rest } = visit;
            const dt = moment(dateOfAppt, 'MM/DD/YYYY').isSame(dateYesterday, "day")
                ? "YESTERDAY"
                : moment(dateOfAppt, 'MM/DD/YYYY').isSame(new Date(), "day")
                    ? "TODAY"
                    : moment(dateOfAppt, 'MM/DD/YYYY').format("ddd MMM D YYYY").toUpperCase();

            return {
                ...acc,
                [dt]: [...(acc[dt] || []), { ...rest }]
            };
        }, {});
        setVisits(visitsFiltered);
    }, [visits]);

    const onChooseRange = (event) => {
        setOption(prevState => {
            return {
                ...prevState,
                option:3
            };
        });
        toggle();        
    }


    const { from, to } = range;
    const modifiers = { start: from, end: to };
    let rangeText = "";
    if (from)
        rangeText = `From: ${moment(from).format("MMMM DD, YYYY")}`;
    if (to)
        rangeText = rangeText + ` To: ${moment(to).format("MMMM DD, YYYY")}`;
    if (!(from || to))
        rangeText = "Select custom range";

    return (
        <div className={`visit-history-container`}>
            {isWaiting && <Spinner fullWidth />}
            <div className="row">
                <div className="col-12 col-lg-6 page-heading-container">
                    <h1 className="page-heading">PAST APPOINTMENTS</h1>
                </div>
                {(providerid || departmentid) && <div className={`col-12 col-lg-6 dropdown-filter-container`}>
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="dropdown-filter">
                        <DropdownToggle caret>
                            <div className="details-icon-prepend">
                                <div className="icon-col"><span className="icon-calendar-form" /></div>
                                <div className="details-col truncate">
                                    {date}
                                </div>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu className={option === 3 ? "date-range" : ""}>
                            <div className={option === 3 ? "row no-gutters" : ""}>
                                <div className={option === 3 ? "col-12 col-sm left-column" : ""}>
                                    <DropdownItem tag="div" onClick={() => { setRange({ from: undefined, to: undefined }); setOption({ date: 'Last 30 Days', option: 0, actualDate: '30 Days' }); }} className={option === 0 ? "selected row" : "row"}>
                                        <div className={"col item-name"}>
                                            <div className={`details-icon-prepend`}>
                                                <div className="icon-col">
                                                    <span className="icon-list-check" />
                                                </div>
                                                <div className="details-col">
                                                    Last 30 Days
								                </div>
                                                </div>
                                            </div>
                                        <div className={"col item-info"}>{lastMonthDropDownItem}</div>
                                        </DropdownItem>
                                        <DropdownItem tag="div" onClick={() => { setRange({ from: undefined, to: undefined }); setOption({ date: `Today (${dateTodaySelected})`, option: 1, actualDate: "TODAY" }); }} className={option === 1 ? "selected row" : "row"}>
                                            <div className={"col item-name"}>
                                                <div className={`details-icon-prepend`}>
                                                    <div className="icon-col">
                                                        <span className="icon-list-check" />
                                                    </div>
                                                    <div className="details-col">
                                                        Today
								                </div>
                                                </div>
                                            </div>
                                            <div className={"col item-info"}>{dateTodayDropDownItem}</div>
                                        </DropdownItem>
                                        <DropdownItem tag="div" onClick={() => { setRange({ from: undefined, to: undefined }); setOption({ date: `Yesterday (${dateYesterdaySelected})`, option: 2, actualDate: "YESTERDAY" }); }} className={option === 2 ? "selected row" : "row"}>
                                            <div className={"col item-name"}>
                                                <div className={`details-icon-prepend`}>
                                                    <div className="icon-col">
                                                        <span className="icon-list-check" />
                                                    </div>
                                                    <div className="details-col">
                                                        Yesterday
							                    </div>
                                                </div>
                                            </div>
                                            <div className={"col item-info"}>{dateYesterdayDropDownItem}</div>
                                        </DropdownItem>
                                        <DropdownItem tag="div" onClick={onChooseRange} className={option === 3 ? "selected row" : "row"}>
                                            <div className={"col item-name"}>
                                                <div className={`details-icon-prepend`}>
                                                    <div className="icon-col">
                                                        <span className="icon-list-check" />
                                                    </div>
                                                    <div className="details-col custom">
                                                        Custom
							                    </div>
                                                </div>
                                            </div>
                                            <div className={"col item-info"}>Select Range</div>
                                        </DropdownItem>

                                    </div>
                                    {option === 3 &&
                                        <div className="col-12 col-sm right-column">
                                            <DayPicker
                                                className="range-selector"
                                                numberOfMonths={windowWidth < 576 ? 1 : 2}
                                                selectedDays={[from, { from, to }]}
                                                modifiers={modifiers}
                                                onDayClick={handleDayClick}
                                                disabledDays={{ after: new Date() }}
                                                toMonth={new Date(dateToday.year(), dateToday.month())}
                                                maxDate={new Date()}

                                            />
                                            <div className="range-text">{rangeText}</div>
                                        </div>
                                    }
                                </div>

                        </DropdownMenu>
                    </Dropdown>
                </div>}
            </div>
            { (!(providerid || departmentid)) && <div className="row no-provider-selected">
                <div className="col-12">
                    Please select a department and provider under Today’s Appointments to view their past appointments.
                </div>
            </div>}
            {(providerid || departmentid) && <div className="row">
                <div className="col-12">
                    <ol className="collection collection-container">
                        <li className={`item-heading item-container col-12 d-none d-lg-block`}>
                            <div className="row">
                                <div className="attribute col">
                                    PATIENT NAME
                            </div>
                                <div className="attribute col">
                                    APPT. TIME
                            </div>
                                <div className="attribute col">
                                    DATE OF BIRTH
                            </div>
                                {employeeRole === "staff" && <div className="attribute col">
                                    PROVIDER
                            </div>}
                                <div className="attribute col">
                                    DEPARTMENT
                            </div>
                                <div className="attribute col">
                                    DURATION
                            </div>

                                <div className="attribute col">
                                    <span>CSN</span>
                                </div>
                            </div>
                        </li>
                        {visitData &&
                            Object.entries(visitData).map((arr, index) => (
                                <li key={index} className={`item item-container col-12`}>
                                    {<div className="row item-date-heading">
                                        <div className="attribute col-12">{arr[0]}</div>
                                    </div>}

                                    {arr[1].map((visit, visitIndex) => (
                                        <div key={visitIndex} className="row">
                                           <div className="attribute patient-name col-6 col-md-3 col-lg">                                                
                                                <span>{visit.patientName}</span>
                                            </div>
                                            <div className="attribute appt-time col-6 col-md-3 col-lg">
                                                <span>{visit.apptTime}</span>
                                            </div>
                                            <div className="attribute col-12 col-md-6 col-lg">
                                                <div className="row">
                                                    <div className="col-6 d-block d-lg-none attribute__label">DATE OF BIRTH</div>
                                                    <div className="col-6 col-lg-12 attribute__value">{(onTheFlyDepartmentId === visit.departmentInternalId || onTheFlyVisitTypeId === visit.visitTypeInternalId) ? "-" : visit.dateOfBirth}</div>
                                                </div>
                                            </div>
                                            {employeeRole === "staff" && <div className="attribute col-md-6 col-12 col-lg">
                                                <div className="row">
                                                    <div className="col-6 d-block d-lg-none attribute__label">PROVIDER</div>
                                                    <div className="col-6 col-lg-12 attribute__value">{visit.providerName}</div>
                                                </div>
                                            </div>}
                                            <div className="attribute col-12 col-md-6 col-lg">
                                                <div className="row">
                                                    <div className="col-6 d-block d-lg-none attribute__label">DEPARTMENT</div>
                                                    <div className="col-6 col-lg-12 attribute__value">{visit.departmentName}</div>
                                                </div>
                                            </div>
                                            <div className="attribute col-12 col-md-6 col-lg">
                                                <div className="row">
                                                    <div className="col-6 d-block d-lg-none attribute__label">DURATION</div>
                                                    <div className="col-6 col-lg-12 attribute__value">{visit.duration}</div>
                                                </div>
                                            </div>
                                            
                                            <div className="attribute col-12 col-md-6 col-lg">
                                                <span className="d-inline d-lg-none">CSN: </span>
                                                <span className="item-csn">{(onTheFlyDepartmentId === visit.departmentInternalId || onTheFlyVisitTypeId === visit.visitTypeInternalId) ? "-" : visit.csnId}</span>
                                            </div>
                                        </div>
                                    ))}
                                </li>
                            ))}

                    </ol>
                </div>
            </div>}
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        visits: state.videoVisit.visitHistory && state.videoVisit.visitHistory.data ? state.videoVisit.visitHistory.data : [],
        isWaiting: state.videoVisit.visitHistory && state.videoVisit.visitHistory.isWaiting ? state.videoVisit.visitHistory.isWaiting : false,        
        employeeRole: state.domain.er
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getAppointmentHistory: ( startDate, endDate, providerid, departmentid) => {
            dispatch({ type: types.APPOINTMENT_HISTORY,  startDate, endDate, providerid, departmentid });
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VisitHistory);